import React, { useEffect, useState } from "react";
import actions from "../../redux/actions";
import { notifySuccess, notifyError } from "../ToastContext";
import moment from "moment";

const AddEditBetGameModal = ({
  handleClientList,
  showModal,
  handleModalClose,
  mode = "add", // "add" or "edit"
  gameData = {}, // Existing game data for edit mode
}) => {
  const initialFormState = {
    id: "0",
    EventId: "",
    Mid: "",
    EventName: "",
    StartTime: "",
    EndTime: "",
    StartNumber: 0,
    EndNumber: 0,
    WinFormula: 0,
    IsOpenToBet: false,
    // DateModify: moment().format("YYYY-MM-DDTHH:mm"),
    Status: true,
    ...gameData, // Use gameData to pre-fill fields in edit mode

  };

  const [formData, setFormData] = useState(initialFormState);
  const [openModal, setOpenModal] = useState(showModal);
  const [errors, setErrors] = useState({});

  const REGEX = {
    name: /^[a-zA-Z_-\s]*$/,
    time: /^\d{2}:\d{2}$/,
    number: /^\d+$/,
  };

  useEffect(() => setOpenModal(showModal), [showModal]);

  useEffect(() => {
    if (mode === "edit") {
      setFormData((prev) => ({ ...prev, ...gameData }));
    }
  }, [gameData, mode]);

  const handleInputChange = ({ target: { id, value } }) => {
    setFormData((prev) => ({
      ...prev,
      [id]: id === "StartNumber" || id === "EndNumber" || id === "WinFormula" ? +value : value,
    }));
    setErrors((prev) => ({ ...prev, [id]: undefined }));
  };

  const validateForm = () => {
    const validationErrors = {};
    const { EventId, EventName, StartTime, EndTime, StartNumber, EndNumber, WinFormula } = formData;

    if (!EventId.trim() || !REGEX.name.test(EventId)) {
      validationErrors.EventId = "Event Id is required and must contain only letters.";
    }
    if (!EventName.trim() || !REGEX.name.test(EventName)) {
      validationErrors.EventName = "Event Name is required and must contain only letters.";
    }
    if (!StartTime) {
      validationErrors.StartTime = "Start Time must be in the format HH:mm.";
    }
    if (!EndTime) {
      validationErrors.EndTime = "End Time must be in the format HH:mm.";
    }
    if (!StartNumber || parseInt(StartNumber, 10) <= 0) {
      validationErrors.StartNumber = "Start Number must be a positive number.";
    }
    if (
      !EndNumber ||
      parseInt(EndNumber, 10) <= 0 ||
      parseInt(EndNumber, 10) <= parseInt(StartNumber, 10)
    ) {
      validationErrors.EndNumber = "End Number must be greater than Start Number.";
    }
    if (!WinFormula || isNaN(WinFormula)) {
      validationErrors.WinFormula = "Win Formula must be a valid number.";
    }

    return validationErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const processedFormData = {
        id: formData.id,
        EventId: String(formData.EventId || ""),
        EventName: String(formData.EventName || ""),
        IsOpenToBet: Boolean(formData.IsOpenToBet),
        StartNumber: parseInt(formData.StartNumber, 10),
        EndNumber: parseInt(formData.EndNumber, 10),
        WinFormula: parseInt(formData.WinFormula, 10),
        StartTime: String(formData.StartTime || ""),
        EndTime: String(formData.EndTime || ""),
        // DateModify: String(formData.DateModify || new Date().toISOString()),
        Status: Boolean(formData.Status),
      };

      try {
        const response =
          mode === "add"
            ? await actions.postSMEventSave(processedFormData)
            : await actions.postSMEventSave(processedFormData);

        if (response?.data?.Status) {
          notifySuccess(response.data.Result);
          handleClientList();
          handleModalClose();
          setFormData(initialFormState);
        } else {
          notifyError(response.data.Result);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  return (
    openModal && (
      <div className="modal" id="createClientModal" tabIndex={-1} role="dialog" style={{ display: "block" }}>
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title">{mode === "add" ? "Add New Game" : "Edit Game"}</h6>
              <button
                className="close"
                type="button"
                aria-label="Close"
                onClick={() => {
                  handleModalClose();
                  setErrors({});
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form-group row">
                <div className="col-sm-6 mb-3">
                  <label>EventId</label>
                  <input
                    type="text"
                    className={`form-control ${errors.EventId ? "is-invalid" : ""}`}
                    id="EventId"
                    value={formData.EventId}
                    onChange={handleInputChange}
                    placeholder="EventId"
                  />
                  {errors.EventId && <div className="invalid-feedback">{errors.EventId}</div>}
                </div>
                <div className="col-sm-6 mb-3">
                  <label>Event Name</label>
                  <input
                    type="text"
                    className={`form-control ${errors.EventName ? "is-invalid" : ""}`}
                    id="EventName"
                    value={formData.EventName}
                    onChange={handleInputChange}
                    placeholder="Event Name"
                  />
                  {errors.EventName && <div className="invalid-feedback">{errors.EventName}</div>}
                </div>
              </div>
              <div className="form-group row">
                <div className="col-sm-6">
                  <label>Start Time</label>
                  <input
                    type="time"
                    className={`form-control ${errors.StartTime ? "is-invalid" : ""}`}
                    id="StartTime"
                    value={formData.StartTime}
                    onChange={handleInputChange}
                    placeholder="HH:mm"
                  />
                  {errors.StartTime && <div className="invalid-feedback">{errors.StartTime}</div>}
                </div>
                <div className="col-sm-6">
                  <label>End Time</label>
                  <input
                    type="time"
                    className={`form-control ${errors.EndTime ? "is-invalid" : ""}`}
                    id="EndTime"
                    value={formData.EndTime}
                    onChange={handleInputChange}
                    placeholder="HH:mm"
                  />
                  {errors.EndTime && <div className="invalid-feedback">{errors.EndTime}</div>}
                </div>
              </div>
              <div className="form-group row">
                <div className="col-sm-6">
                  <label>Start Number</label>
                  <input
                    type="number"
                    className={`form-control ${errors.StartNumber ? "is-invalid" : ""}`}
                    id="StartNumber"
                    value={formData.StartNumber}
                    onChange={handleInputChange}
                    placeholder="Start Number"
                  />
                  {errors.StartNumber && <div className="invalid-feedback">{errors.StartNumber}</div>}
                </div>
                <div className="col-sm-6">
                  <label>End Number</label>
                  <input
                    type="number"
                    className={`form-control ${errors.EndNumber ? "is-invalid" : ""}`}
                    id="EndNumber"
                    value={formData.EndNumber}
                    onChange={handleInputChange}
                    placeholder="End Number"
                  />
                  {errors.EndNumber && <div className="invalid-feedback">{errors.EndNumber}</div>}
                </div>
              </div>
              <div className="form-group row">
                <div className="col-sm-6">
                  <label>Win Formula</label>
                  <input
                    type="number"
                    className={`form-control ${errors.WinFormula ? "is-invalid" : ""}`}
                    id="WinFormula"
                    value={formData.WinFormula}
                    onChange={handleInputChange}
                    placeholder="Win Formula"
                  />
                  {errors.WinFormula && <div className="invalid-feedback">{errors.WinFormula}</div>}
                </div>
                <div className="col-sm-6">
                  <label>Active Bet</label>
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="IsOpenToBet"
                      checked={formData.IsOpenToBet}
                      onChange={({ target: { checked } }) =>
                        setFormData((prev) => ({ ...prev, IsOpenToBet: checked }))
                      }
                    />
                    <label className="form-check-label" htmlFor="IsOpenToBet">
                      {formData.IsOpenToBet ? "Active Bet" : "Inactive Bet"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleModalClose}>
                Close
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                {mode === "add" ? "Save" : "Update"}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default AddEditBetGameModal;
